import Immutable from 'immutable';

// constants

import { LOCATION_CHANGE } from 'react-router-redux';

const initialState = Immutable.fromJS({ locationBeforeTransitions: null });

export default (state = initialState, action) => {
  if (action.type === LOCATION_CHANGE) {
    return state.set('locationBeforeTransitions', action.payload);
  }

  return state;
};



// WEBPACK FOOTER //
// ./app/reducers/routing.js